// @flow
import React from "react";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoJanelaMovel,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  getJanelaMovelSelecionada,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarPeriodoDiarioSemPeriodicidade = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const janelaMovel = getJanelaMovelSelecionada(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        janelaMovel: janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        dataBase: dataBase,
        janelaMovel: janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoDiarioSemPeriodicidade = () => {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <SelecaoJanelaMovel />
      </>
    );
  } else {
    return (
      <>
        <SelecaoPeriodo exibirPeriodicidade={false} />
        <SelecaoAjusteDias />
        <SelecaoCasasDecimais />
      </>
    );
  }
};

export default PeriodoDiarioSemPeriodicidade;
